import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgGroup3Fill = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-.5 -.5 16 16"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {"\n    Group 3 Fill Streamline Icon: https://streamlinehq.com\n  "}
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <g fill="none">
      <path d="M15 0v15H0V0zM7.871 14.5361l-.0073.001-.0444.0223-.0119.0023-.0095-.0023-.0443-.0222c-.0062-.002-.0117-.0003-.0148.0034l-.0025.0068-.0107.267.003.0128.007.0076.0647.0463.0093.0024.0073-.0024.0648-.0463.0079-.01.002-.0104-.0106-.267c-.0012-.0063-.0054-.0103-.01-.0113m.1655-.0703-.0087.0013-.1154.0577-.0062.0064-.0017.007.0112.2684.003.008.0053.0045.1256.0579c.0075.0023.0143-.0001.0178-.005l.0025-.0088-.0213-.3841c-.0015-.0075-.0065-.0122-.0121-.0133m-.4471.0013a.0144.0144 0 0 0-.0171.0033l-.0036.0087-.0213.3842a.014.014 0 0 0 .0105.0146l.0098-.0009.1256-.058.0058-.005.0025-.0074.0112-.2684-.002-.0079-.006-.0055z" />
      <path
        fill="currentColor"
        d="M7.5 7.5c1.1706 0 2.2317.3873 3.0091.9294.7397.5158 1.3659 1.282 1.3659 2.1063 0 .4527-.1929.8275-.4972 1.1067-.2863.2627-.6601.433-1.0451.5495-.7696.233-1.7825.3081-2.8327.3081s-2.0631-.0752-2.8327-.3081c-.385-.1165-.7588-.2868-1.0451-.5495-.3043-.2792-.4972-.654-.4972-1.1067 0-.8244.6262-1.5905 1.3658-2.1063C5.2683 7.8873 6.3294 7.5 7.5 7.5m4.375.625c.6528 0 1.2452.2153 1.6833.5209.4004.2792.8167.744.8167 1.3095 0 .3232-.1404.5914-.3498.7835-.1915.1757-.428.2785-.6433.3437-.2938.0888-.6407.1344-1.0007.1544.0764-.2155.1188-.45.1188-.7013 0-.9596-.5994-1.7742-1.27-2.34a3 3 0 0 1 .645-.0707m-8.75 0c.2233 0 .4396.0252.645.0706-.6706.5659-1.27 1.3805-1.27 2.34 0 .2513.0424.4859.1188.7014-.36-.02-.7069-.0656-1.0007-.1544-.2153-.0652-.4519-.168-.6433-.3437-.2094-.192-.3498-.4603-.3498-.7835 0-.5656.4163-1.0303.8167-1.3095.4381-.3056 1.0305-.5209 1.6833-.5209m8.4375-3.75c.863 0 1.5625.6996 1.5625 1.5625S12.4254 7.5 11.5625 7.5 10 6.8004 10 5.9375s.6996-1.5625 1.5625-1.5625m-8.125 0C4.3005 4.375 5 5.0746 5 5.9375S4.3004 7.5 3.4375 7.5 1.875 6.8004 1.875 5.9375 2.5746 4.375 3.4375 4.375M7.5 1.875c1.3807 0 2.5 1.1193 2.5 2.5s-1.1193 2.5-2.5 2.5S5 5.7557 5 4.375s1.1193-2.5 2.5-2.5"
      />
    </g>
  </svg>
);
export default SvgGroup3Fill;
